import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { AlgoliaMatter } from '@fnModels/algolia/matter';
import { OutstandingRequisitionsResponse } from '@fnModels/requisitions';
import { OutstandingUndertakingsResponse } from '@fnModels/undertakings';
import { Address } from '@models/address';
import { Matter, MatterFileType, MatterSource } from '@models/matter';
import { UserMatterViewHistory } from '@models/userViewHistory';
import { MatterWithType } from 'src/app/private/calendar/calendar.model';
import { TestHooks } from './matter-tile.hooks';

@Component({
	selector: 'app-matter-tile',
	templateUrl: './matter-tile.component.html',
	styleUrls: ['./matter-tile.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterTileComponent {
	testHooks = TestHooks;
	ICON = ICON;
	MatterFiletype = MatterFileType;
	MatterSource = MatterSource;

	@Input()
	@HostBinding('class.condensed')
	condensed = false;

	@Input() showAppointmentData = false;
	@Input() showRequisitionData = false;

	// yes, this is goofy - but this is being fed by a number of different sources,
	// so i'm keeping the input open to anything that's acceptable, and relying on
	// alias getters to figure out what's needed where
	@Input() matter!:
		| Matter
		| MatterWithType
		| UserMatterViewHistory
		| AlgoliaMatter
		| OutstandingRequisitionsResponse
		| OutstandingUndertakingsResponse;

	@Input() @HostBinding('class.mini') mini = false;

	get asMatter(): Matter {
		return this.matter as Matter;
	}

	get asWithType(): MatterWithType {
		return this.matter as MatterWithType;
	}

	get asHistory(): UserMatterViewHistory {
		return this.matter as UserMatterViewHistory;
	}

	get asAlgolia(): AlgoliaMatter {
		return this.matter as AlgoliaMatter;
	}

	get address(): Address {
		// OutstandingRequisitionsResponse -> has no address
		return (
			this.asHistory?.address ||
			this.asMatter?.propertyDetails?.address ||
			this.asAlgolia?.address ||
			this.asWithType?.propertyDetails?.address
		);
	}

	get clerkId(): string {
		return (
			this.asHistory?.assignedClerk?.id ||
			this.asAlgolia?.clerkId ||
			this.asMatter?.clerkAssigned?.id
		);
	}

	get lawyerId(): string {
		return (
			this.asHistory?.assignedLawyer?.id ||
			this.asAlgolia?.lawyerId ||
			this.asMatter?.lawyerAssigned?.id
		);
	}

	get showOccupancyIcon(): boolean {
		return !!this.asMatter?.occupancyDate;
	}
}
